import { injectable } from 'inversify';
import { LogApiService, LogEventLevel } from 'src/api';

export enum LogLevel {
    Debug = 0,
    Info = 1,
    Warn = 2,
    Error = 3,
}

@injectable()
export class LoggerStore {
    constructor(private logApi: LogApiService) {}

    debug(message: string, code?: string) {
        this.log(LogLevel.Debug, message, code);
    }

    info(message: string, code?: string) {
        this.log(LogLevel.Info, message, code);
    }

    warn(message: string, code?: string) {
        this.log(LogLevel.Warn, message, code);
    }

    error(message: string, code?: string) {
        this.log(LogLevel.Error, message, code);
    }

    log(level: LogLevel, message: string, code?: string) {
        try {
            if (!message) {
                return;
            }

            this.logApi.log({
                level: level as LogEventLevel,
                message: message.toString(),
                code: code ? code.toString() : undefined,
            });
        } catch (e) {}
    }
}
